var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteSticky(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 32H96.01C60.66 32 32.0085 60.65 32.0065 96L32 415.1C31.998 451.3 60.65 480 96 480H328.1C353.56 480 377.98 469.88 395.99 451.88L451.87 395.99C469.9 377.1 480 353.6 480 328.1V96C480 60.8 451.2 32 416 32ZM84.69 427.3C82.94 425.6 80 421.8 80 416L80.0195 96.9C80.02 87.18 87.2 80 96.02 80H416C424.674 80 432 87.328 432 96V288H344C313.1 288 288 313.1 288 344V432H96C90.23 432 86.44 429.1 84.69 427.3ZM362.1 417.9C354.9 425.1 345.8 429.6 336 431.2V344C336 339.594 339.594 336 344 336H431.23C429.613 345.812 425.115 354.88 417.94 362.05L362.1 417.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteSticky);
export default __webpack_public_path__ + "static/media/noteSticky.4c25fd5f7f67e54ca98adabfbd849f1b.svg";
export { ForwardRef as ReactComponent };